import type { AxiosResponse } from 'axios';
import { PATHS } from '../config';
import { dynoape, rawDynoape } from '../dynoape';

const getLogo = async (
    token: string,
    orgId: string,
): Promise<AxiosResponse<Blob>> =>
    await rawDynoape.get<Blob>(PATHS.logo(orgId), {
        method: 'GET',
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

const uploadLogo = async (
    token: string,
    csrfToken: string,
    orgId: string,
    file: File,
): Promise<unknown> => {
    const formData = new FormData();
    formData.append('file', file);

    return await dynoape.put(PATHS.logo(orgId), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
            'X-XSRF-TOKEN': csrfToken,
        },
    });
};

const LogoService = { getLogo, uploadLogo };

export default LogoService;
